"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usePrevious;

var _react = require("react");

function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VQcmV2aW91cyIsInZhbHVlIiwicmVmIiwidXNlUmVmIiwidXNlRWZmZWN0IiwiY3VycmVudCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL2ludGVybmFsL3VzZVByZXZpb3VzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZUVmZmVjdCwgdXNlUmVmIH0gZnJvbSAncmVhY3QnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VQcmV2aW91czxUPih2YWx1ZTogVCk6IFQge1xuICBjb25zdCByZWYgPSB1c2VSZWY8VD4oKTtcblxuICB1c2VFZmZlY3QoKCkgPT4ge1xuICAgIHJlZi5jdXJyZW50ID0gdmFsdWU7XG4gIH0pO1xuXG4gIHJldHVybiByZWYuY3VycmVudDtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVlLFNBQVNBLFdBQVQsQ0FBd0JDLEtBQXhCLEVBQXFDO0VBQ2xELElBQU1DLEdBQUcsR0FBRyxJQUFBQyxhQUFBLEdBQVo7RUFFQSxJQUFBQyxnQkFBQSxFQUFVLFlBQU07SUFDZEYsR0FBRyxDQUFDRyxPQUFKLEdBQWNKLEtBQWQ7RUFDRCxDQUZEO0VBSUEsT0FBT0MsR0FBRyxDQUFDRyxPQUFYO0FBQ0QifQ==